module.exports = __webpack_public_path__ + "img/horizontal_6_3_0.aeed787f.png";